// layout.js
import React, { useEffect, useLayoutEffect, memo } from "react";
import UserStore from "../../store/UserStore";
import Footer from "../Footer";
import Header from "./Header";
import Nav from "./Nav";

function Layout({ children }) {
  useEffect(() => {
    document.querySelector('body').style.paddingTop = 0;
  }, []);

  useLayoutEffect(() => {
    if (!UserStore.isAuthenticated()) {
      window.location.href = "/login";
    }
  }, []);

  if (!UserStore.isAuthenticated()) {
    return <div />;
  }

  return (
    <>
      <Nav />
      <div className="es-content">
        <Header />
        {children}
        <Footer />
      </div>
    </>
  );
}

export default memo(Layout);
